import { Component } from 'react';
import Helmet from 'react-helmet';

import Icon from 'react-fa';

import { titles } from '../../data';
import CommonComponents from './CommonComponents';
import Title from '../modules/Title';

export default class DisabilitySupports extends Component {
  render() {

    const page = this.props.page;

    return (
      <div>
        <Helmet title={titles.services.disability_supports} titleTemplate={titles.titleTemplate} />
        <CommonComponents {...this.props}>

          <div className="services__overview">
            <div className="desc" dangerouslySetInnerHTML={{__html: page.acf.disability_supports_overview}} />
          </div>

          {/* 居宅介護サービス */}
          <section className="services__item" id="home-visit-support">
            <Title header="h2" title="居宅介護サービス" />
            <div className="services__content">
              {/* 概要 */}
              {page.acf.hv_overview
                ?
                  <div className="services__content__overview has-image">
                    <Icon name="lightbulb-o" />
                    <div dangerouslySetInnerHTML={{__html: page.acf.hv_overview}} />
                    <figure className="image">
                      <img src={require('../../assets/images/disability-supports-home-care.png')} />
                    </figure>
                  </div>
                : ''
              }
            </div>
          </section>

          {/* 重度訪問介護 */}
          <section className="services__item" id="severe-handicapped-support">
            <Title header="h2" title="重度訪問介護" />
            <div className="services__content">
              {/* 概要 */}
              {page.acf.sv_overview
                ?
                  <div className="services__content__overview">
                    <Icon name="lightbulb-o" />
                    <div dangerouslySetInnerHTML={{__html: page.acf.sv_overview}} />
                  </div>
                : ''
              }
            </div>
          </section>

          {/* 同行支援 */}
          <section className="services__item" id="companion-support">
            <Title header="h2" title="同行援護" />
            <div className="services__content">
              {/* 概要 */}
              {page.acf.companion_support_overview
                ?
                  <div className="services__content__overview has-image">
                    <Icon name="lightbulb-o" />
                    <div dangerouslySetInnerHTML={{__html: page.acf.companion_support_overview}} />
                    <figure className="image">
                      <img src={require('../../assets/images/disability-supports-companion-support.png')} />
                    </figure>
                  </div>
                : ''
              }
            </div>
          </section>

          {/* 移動支援 */}
          <section className="services__item" id="move-support">
            <Title header="h2" title="移動支援" />
            <div className="services__content">
              {/* 概要 */}
              {page.acf.move_support_overview
                ?
                  <div className="services__content__overview">
                    <Icon name="lightbulb-o" />
                    <div dangerouslySetInnerHTML={{__html: page.acf.move_support_overview}} />
                  </div>
                : ''
              }
            </div>
          </section>

        </CommonComponents>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Services/DisabilitySupports.js
 **/